/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeALeftIcon20Solid = forwardRef('ArrowShapeALeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.227 11.588a2.25 2.25 0 0 1 0-3.18l6.967-6.976c.85-.851 2.305-.25 2.305.954V5.25H16a2 2 0 0 1 2 2v5.5a2 2 0 0 1-2 2h-4.5v2.861c0 1.203-1.455 1.806-2.305.954l-6.967-6.977Z" })));
});
